import React from "react";
import Modal from "../../../components/general/Modal";
import Button from "../../../components/general/Button";
import GlobalStyle from "../../../styles/globalStyles";
import { Container, SubTitle, Title, Footer } from "./styles";
import { useDispatch } from "react-redux";
import { handleDowngradeRank } from "../../../state/users/actions";
import { toastAlert } from "../../../components/Toastify";

const DowngradeRankModal = ({ isOpen, onClose, item }) => {
  const dispatch = useDispatch();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector="#root"
      className="nodrag"
    >
      <GlobalStyle />
      <Container>
        <Title>Confirme a Modificação de Rank </Title>
        <SubTitle>Usuario a se tornar colaborador: {item.username} </SubTitle>
        <Footer>
          <Button content={"Cancelar"} onClick={onClose} outline />
          <Button
            content={"Rebaixar"}
            onClick={() =>
              dispatch(
                handleDowngradeRank({
                  userId: item._id,
                })
              )
                .then(() => {
                  toastAlert({
                    msg:
                      "Usuario " +
                      item.username +
                      " transformado em colaborador com sucesso!",
                  });
                  onClose();
                })
                .catch(() =>
                  toastAlert({
                    msg:
                      "Ocorreu um erro ao rebaixar o usuario : " +
                      item.username +
                      "!",
                    isError: true,
                  })
                )
            }
          />
        </Footer>
      </Container>
    </Modal>
  );
};

export default DowngradeRankModal;
